import { globalStyle, style } from '@vanilla-extract/css';

const balance = style({
  fontWeight: 'bold',
  fontSize: '4rem',
  lineHeight: '4.8rem',
});

globalStyle(`${balance} span`, {
  fontSize: '3.2rem',
});

const advantage = style({
  position: 'relative',
  '::before': {
    position: 'absolute',
    top: '50%',
    width: '1.2rem',
    height: '0.6rem',
    background: 'var(--gradient-red)',
    borderTopLeftRadius: '0.7rem',
    borderTopRightRadius: '0.7rem',
    transform: 'translateY(-50%)',
    content: '""',
  },
});

globalStyle(`${advantage} span`, {
  marginLeft: '2.2rem',
});

export const css = {
  balance,
  advantage,
};
